import stylesParams from '../Notifications/stylesParams';

export default stylesParams;
